import script from "./FormLoginModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormLoginModal.vue?vue&type=script&lang=ts&setup=true"

import "./FormLoginModal.vue?vue&type=style&index=0&id=94e458e4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94e458e4"]])

export default __exports__